class InfiniteScroll extends HTMLElement {
  constructor() {
    super();
    this.nextUrl = this.dataset.nextUrl;
    this.productGrid = document.getElementById(this.dataset.gridId);
    this.loading = false;
    this.observer = null;
  }

  connectedCallback() {
    if (!this.nextUrl || !this.productGrid) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.loading) {
            this.loadMore();
          }
        });
      },
      { rootMargin: '400px' }
    );

    this.observer.observe(this);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  async loadMore() {
    this.loading = true;
    this.classList.add('is-loading');

    try {
      const response = await fetch(this.nextUrl);
      if (!response.ok) throw new Error(response.statusText);

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newItems = doc.querySelectorAll(
        `#${this.dataset.gridId} > .grid__item`
      );

      if (newItems.length) {
        const fragment = document.createDocumentFragment();
        newItems.forEach((item) => {
          fragment.appendChild(document.importNode(item, true));
        });
        this.productGrid.appendChild(fragment);
      }

      const nextPageLink = doc.querySelector('infinite-scroll');
      if (nextPageLink && nextPageLink.dataset.nextUrl) {
        this.nextUrl = nextPageLink.dataset.nextUrl;
        this.loading = false;
        this.classList.remove('is-loading');
      } else {
        this.complete();
      }
    } catch (error) {
      console.error('Infinite scroll error:', error);
      this.complete();
    }
  }

  complete() {
    this.loading = true;
    this.classList.remove('is-loading');
    this.classList.add('is-complete');
    if (this.observer) this.observer.disconnect();
  }
}

if (!customElements.get('infinite-scroll')) {
  customElements.define('infinite-scroll', InfiniteScroll);
}
